module.exports = __webpack_public_path__ + "img/licensecheck.6599faad.png";